<template>
  <div>
    <el-button :plain="true" @click="open2">成功</el-button>
    <el-button :plain="true" @click="open3">警告</el-button>
    <el-button :plain="true" @click="open1">消息</el-button>
    <el-button :plain="true" @click="open4">错误</el-button>

      <i class="iconfont" style="color:#999999;margin-right:8px">&#xe75d;</i>
  </div>
</template>

<!--
  功能：功能描述
  汪振涛
  时间：2021年06月02日 16:01:58
  版本：v1.0
-->
<script>
export default {
  components: {},
  name: "SrMessage",
  props: {},
  data() {
    return {};
  },
  methods: {
    open1() {
      this.$message("这是一条消息提示");
    },
    open2() {
      this.$message({
        message: "恭喜你，这是一条成功消息",
        type: "success",
        center:true,
        duration: 0
      });
    },

    open3() {
      this.$message({
        message: "警告哦，这是一条警告消息",
        type: "warning",
      });
    },

    open4() {
      this.$message.error("错了哦，这是一条错误消息");
    },
  },
};
</script>




// WEBPACK FOOTER //
// packages/SrMessage/SrMessage.vue